
function DateInput({ month, day, year, setBirthday }) {

    return (
        <>
            <label>Birthday</label>
            <div className="birthday">
                <input className="col-span-4" type="number" name="month" value={month} onChange={setBirthday} placeholder="Month (2 digits)" />

                <input className="col-span-4" type="number" name="day" value={day} onChange={setBirthday} placeholder="Day (2 digits)" />

                <input className="col-span-4" type="number" name="year" value={year} onChange={setBirthday} placeholder="Year (4 digits)" />
            </div>
        </>
    )
}

export default DateInput